<template>
  <div class="time_trading">
    <ul class="type_title">
      <li
        v-for="(item, index) in tabList"
        :key="index"
        :class="{ activeTabTitle: shimTab === item.name }"
        @click="handleTab(item.name)"
      >
        {{ item.title }}
      </li>
    </ul>
    <div class="type_content">
      <!-- 盘口 -->
      <div
        :class="{ activeTabContent: shimTab === 'handicap' }"
        class="handicap left_handicap"
      >
        <div class="handicap_head">
          <div
            class="icon_box"
            v-for="(item, index) in handicapList"
            :key="index"
            @click="handleHandicap(item)"
          >
            <img
              v-if="shimHandicap === item.name"
              :src="item.imageAtive"
              alt=""
              class="full_img"
            />
            <img v-else :src="item.imageNagetive" alt="" class="full_img" />
          </div>
        </div>
        <div class="handicap_body">
          <dl>
            <dt class="dt_title">
              <span>{{ $t('价格') }} ({{ quoteCurrency }})</span>
              <span>{{ $t('数量') }} ({{ baseCurrency }})</span>
              <span>{{ $t('累计') }} ({{ baseCurrency }})</span>
            </dt>
            <dd class="dd_description">
              <div
                :style="{ top: buySellTop + 'px' }"
                class="description_content"
              >
                <ul class="sell_ul">
                  <li
                    class="sell_li jump"
                    v-for="(item, index) in sellHandicap"
                    :key="index"
                    :style="{
                      backgroundSize: `${
                        isNaN(item.n)
                          ? 0
                          : (Number(item.n) / sellMaxTotal) * 100
                      }% 100%`
                    }"
                    @click="handlePrice(item.p)"
                  >
                    <span>{{ item.p | initFilter('---') }}</span>
                    <span>{{ item.n | initFilter('---') }}</span>
                    <span>{{ item.l | initFilter('---') }}</span>
                  </li>
                </ul>
                <div class="coin_price">
                  <span
                    :class="{
                      current_up: Number(tradingPairData.ratio) > 0,
                      current_down: Number(tradingPairData.ratio) < 0
                    }"
                    class="price"
                  >
                    {{ currentPrice }}</span
                  >
                  <span class="more" @click="jumpTo('/buyingSelling')">{{
                    $t('更多')
                  }}</span>
                </div>
                <ul class="buy_ul">
                  <li
                    class="buy_li jump"
                    v-for="(item, index) in buyHandicap"
                    :key="index"
                    :style="{
                      backgroundSize: `${
                        isNaN(item.n) ? 0 : (Number(item.n) / buyMaxTotal) * 100
                      }% 100%`
                    }"
                    @click="handlePrice(item.p)"
                  >
                    <span>{{ item.p | initFilter('---') }}</span>
                    <span>{{ item.n | initFilter('---') }}</span>
                    <span>{{ item.l | initFilter('---') }}</span>
                  </li>
                </ul>
              </div>
            </dd>
          </dl>
        </div>
      </div>

      <!-- 实时成交 -->
      <div :class="{ activeTabContent: shimTab === 'trading' }" class="trading">
        <dl class="trading_dl">
          <dt class="trading_dt">
            <span>{{ $t('时间') }}</span>
            <span>{{ $t('价格') }} ({{ quoteCurrency }})</span>
            <span>{{ $t('数量') }} ({{ baseCurrency }})</span>
          </dt>
          <dd class="trading_dd">
            <dl v-if="realArray.length > 0" class="list_box">
              <dd v-for="(item, index) in realArray" :key="index">
                <span>{{ item.t }}</span>
                <span :class="item.s === 'sell' ? 'sell_price' : 'buy_price'">{{
                  item.p
                }}</span>
                <span>{{ item.n }}</span>
              </dd>
            </dl>
            <NoData
              v-else
              :sceneType="currentSkin === 'black' ? 'night' : 'day'"
            ></NoData>
          </dd>
        </dl>
      </div>
    </div>
  </div>
</template>
<script>
import { sendWSPush } from '@/utils/webSocket'
import { mapState, mapGetters } from 'vuex'
import {
  SET_HANDICAP_FIRST_PRICE,
  SET_CURRENT_HANDICAP,
  SET_BUYSELL_TOP
} from '@/store/mutation-types'
import { tradingPairFormatReverse } from '@/utils'

export default {
  data() {
    return {
      loading: null, // 实时成交 loading
      tabList: [
        {
          title: this.$t('盘口'),
          name: 'handicap'
        },
        {
          title: this.$t('实时成交'),
          name: 'trading'
        }
      ],
      handicapList: [
        {
          name: 'buySell',
          imageNagetive: require('./../../../../assets/images/panko-quanbu-weixuan.png'),
          imageAtive: require('./../../../../assets/images/panko-quanbu-yixuan.png')
        },
        {
          name: 'buy',
          imageNagetive: require('./../../../../assets/images/panko-lvse-weixuanzhe.png'),
          imageAtive: require('./../../../../assets/images/panko-lvse-yixuan.png')
        },
        {
          name: 'sell',
          imageNagetive: require('./../../../../assets/images/panko-hongse-weixuanzhe.png'),
          imageAtive: require('./../../../../assets/images/panko-hongse-yixuan.png')
        }
      ],
      shimTab: 'handicap',
      sellHandicap: 25, // 盘口卖盘数据
      buyHandicap: 25, // 盘口买盘数据
      realArray: [], // 实时成交数据
      sellMaxTotal: 1,
      buyMaxTotal: 1
    }
  },
  computed: {
    ...mapState({
      shimHandicap: (state) => state.transaction.shimHandicap,
      buySellTop: (state) => state.transaction.buySellTop,
      tradingPairData: (state) => state.transaction.tradingPairData,
      currentSkin: (state) => state.transaction.currentSkin,
      plateData: (state) => state.transaction.plateData,
      realData: (state) => state.transaction.realData,
      handicapFirstPrice: (state) => state.transaction.handicapFirstPrice
    }),
    ...mapGetters([
      'baseCurrency',
      'quoteCurrency',
      'parameterizedTradingPair',
      'tradingPair'
    ]),
    currentPrice() {
      return this.tradingPairData.price || '---'
    }
  },
  created() {
    this.loading = this.$loading({
      target: '.trading_dd',
      duration: 0,
      background:
        this.currentSkin === 'black'
          ? 'rgba(23, 27, 43, 1)'
          : 'rgba(255, 255, 255, 1)'
    })
    // eslint-disable-next-line
    sendWSPush({ channel: this.parameterizedTradingPair, language: 'zh' })
  },
  watch: {
    tradingPair() {
      this.realArray = [] // 用户点击币种时清空实时成交数据
      this.loading = this.$loading({
        target: '.trading_dd',
        duration: 0,
        background:
          this.currentSkin === 'black'
            ? 'rgba(23, 27, 43, 1)'
            : 'rgba(255, 255, 255, 1)'
      }) // 实时数据loading

      // 将交易操作栏输入框中的值清空
      this.$store.commit(`transaction/${SET_HANDICAP_FIRST_PRICE}`, {
        unassigned: true,
        buyFirstPrice: '',
        sellFirstPrice: ''
      })

      // 盘口数据loading
      this.sellHandicap = 25 // 盘口卖盘数据
      this.buyHandicap = 25 // 盘口买盘数据

      // eslint-disable-next-line
      sendWSPush({
        channel: this.parameterizedTradingPair,
        language: 'zh'
      })
    },
    plateData(newVal) {
      if (this.tradingPair === tradingPairFormatReverse(newVal.symbol)) {
        const sellData = newVal.sale.reverse()
        const buyData = newVal.buy
        this.sellMaxTotal = this.assembleHandicap(sellData)
        this.buyMaxTotal = this.assembleHandicap(buyData)
        this.sellHandicap = sellData
        this.buyHandicap = buyData

        if (this.handicapFirstPrice.unassigned) {
          this.$store.commit(`transaction/${SET_HANDICAP_FIRST_PRICE}`, {
            unassigned: false,
            buyFirstPrice: this.buyHandicap[0].p,
            sellFirstPrice: this.sellHandicap[0].p
          })
        }
      }
    },
    realData(newData) {
      if (this.loading) this.loading.close()

      const ret = newData.slice(0, 24)
      if (ret.length < 24) {
        ret.push(...this.realArray.slice(0, 24 - ret.length))
      }
      this.realArray = ret
    }
  },
  methods: {
    jumpTo(p) {
      this.$router.push({ path: p })
    },
    handleTab(name) {
      switch (name) {
        case 'handicap':
          this.shimTab = 'handicap'
          break
        case 'trading':
          this.shimTab = 'trading'
          break
      }
    },
    handleHandicap(item) {
      this.$store.commit(`transaction/${SET_CURRENT_HANDICAP}`, item.name)
      switch (item.name) {
        case 'buySell':
          this.$store.commit(`transaction/${SET_BUYSELL_TOP}`, -420)
          break
        case 'buy':
          this.$store.commit(`transaction/${SET_BUYSELL_TOP}`, -750)
          break
        case 'sell':
          this.$store.commit(`transaction/${SET_BUYSELL_TOP}`, -90)
      }
    },
    handlePrice(price) {
      if (price) {
        const priceObj = {
          buyFirstPrice: price || '',
          sellFirstPrice: price || ''
        }
        this.$store.commit(`transaction/${SET_HANDICAP_FIRST_PRICE}`, priceObj)
      }
    },
    // 组装盘口数据
    assembleHandicap(array) {
      let maxTotal = 0 // 初始最大值为零
      if (array.length < 25) {
        const targetLength = 25 - array.length
        for (let i = 0; i < targetLength; i++) {
          array.push(['---', '---', '---'])
        }
      } else {
        const deleteLength = array.length - 25
        array.splice(25, deleteLength)
      }
      for (const bar of array) {
        if (bar.n !== '---' && Number(bar.n) > maxTotal) {
          maxTotal = Number(bar.n)
        }
      }
      return maxTotal
    }
  }
}
</script>
<style lang="less" scoped>
.time_trading {
  height: 100%;
  width: 650px;
  .type_title {
    display: flex;
    li {
      padding: 11px 24px;
      width: 100%;
      line-height: 20px;
      font-size: 16px;
      font-family: PingFangSC-Medium, 'PingFang SC';
      font-weight: 500;
      color: @textColor4;
      background: @titleBgColor1;
      border-top: 2px solid @titleBgColor1;
    }
    li:first-child {
      margin-right: 10px;
    }
  }
  .type_content {
    // 布局要点
    height: calc(100% - 44px);
    display: flex;
    .handicap,
    .trading {
      width: 100%;
      background: @contentBgColor1;
    }
    .left_handicap {
      margin-right: 10px;
    }
    .handicap {
      .handicap_head {
        padding: 8px 20px;
        display: flex;
        flex-direction: row;
        align-items: center;
        .icon_box {
          margin-right: 4px;
          width: 20px;
          height: 20px;
          cursor: pointer;
        }
        .icon_box:nth-child(3) {
          margin-right: 8px;
        }
      }
      .handicap_body {
        height: calc(100% - 36px);
        dl {
          height: 100%;
          position: relative;
          .dt_title {
            padding: 7px 20px 6px 20px;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            position: relative;
            span {
              font-size: 12px;
              font-weight: 400;
              color: @textColor2;
              line-height: 17px;
            }
            span:nth-child(2) {
              position: absolute;
              left: 132px;
            }
          }
          .dd_description {
            height: calc(100% - 30px);
            overflow: hidden;
            position: relative;
            .description_content {
              position: absolute;
              width: 100%;
              top: -210px;
              .sell_ul {
                display: flex;
                flex-direction: column-reverse;
                .sell_li {
                  position: relative;
                  padding: 5px 20px;
                  display: flex;
                  flex-direction: row;
                  justify-content: space-between;
                  align-items: center;
                  background-image: linear-gradient(
                    rgba(250, 82, 82, 0.1),
                    rgba(250, 82, 82, 0.1)
                  );
                  background-size: 0% 100%;
                  background-position: 100% 100%;
                  background-repeat: no-repeat;
                  span {
                    font-size: 14px;
                    font-weight: 400;
                    color: @textColor3;
                    line-height: 20px;
                  }
                  span:first-child {
                    color: rgba(255, 63, 74, 1);
                  }
                  span:nth-child(2) {
                    position: absolute;
                    right: 132px;
                  }
                  &:hover {
                    background-color: @hoverBgColorOpacity;
                  }
                }
              }
              .coin_price {
                padding: 10px 20px;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
                .price {
                  font-size: 22px;
                  font-weight: 400;
                  color: @textColor4;
                  line-height: 30px;
                }
                .more {
                  font-size: 14px;
                  font-weight: 400;
                  color: rgba(66, 179, 250, 1);
                  line-height: 20px;
                  cursor: pointer;
                }
                // 动态控制字体颜色
                .current_up {
                  color: #3baf7c;
                }
                .current_down {
                  color: #ff3f4a;
                }
              }
              .buy_ul {
                .buy_li {
                  position: relative;
                  padding: 5px 20px;
                  display: flex;
                  flex-direction: row;
                  justify-content: space-between;
                  align-items: center;
                  background-image: linear-gradient(
                    rgba(18, 184, 134, 0.1),
                    rgba(18, 184, 134, 0.1)
                  );
                  background-size: 0% 100%;
                  background-position: 100% 100%;
                  background-repeat: no-repeat;
                  span {
                    font-size: 14px;
                    font-weight: 400;
                    color: @textColor3;
                    line-height: 20px;
                  }
                  span:first-child {
                    color: rgba(42, 184, 134, 1);
                  }
                  span:nth-child(2) {
                    position: absolute;
                    right: 132px;
                  }
                  &:hover {
                    background-color: @hoverBgColorOpacity;
                  }
                }
              }
            }
          }
        }
      }
    }

    .trading {
      .trading_dl {
        margin-top: 10px;
        height: calc(100% - 10px);
        .trading_dt {
          margin-bottom: 10px;
          padding: 7px 20px 6px;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          position: relative;
          span {
            font-size: 12px;
            font-weight: 400;
            color: @textColor2;
            line-height: 17px;
          }
          span:nth-child(2) {
            position: absolute;
            left: 128px;
          }
        }
        .trading_dd {
          height: calc(100% - 41px);
          overflow-y: auto;
          &::-webkit-scrollbar {
            display: none;
          }
          .list_box {
            dd {
              padding: 5px 20px;
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              align-items: center;
              position: relative;
              span {
                font-size: 14px;
                font-weight: 400;
                color: @textColor3;
                line-height: 20px;
              }
              span:nth-child(2) {
                position: absolute;
                left: 128px;
              }
              // 卖出价格
              .sell_price {
                color: #ff3f4a;
              }
              // 买入价格
              .buy_price {
                color: #41b37e;
              }
            }
          }
        }
      }
    }
  }
}

@media screen and (max-width: 1719px) {
  .time_trading {
    width: 320px;
    .type_title {
      background: @titleBgColor1;
      li {
        width: auto;
        cursor: pointer;
      }
      li.activeTabTitle {
        margin-right: 0;
        border-top: 2px solid rgba(66, 179, 250, 1);
        background: @contentBgColor1;
      }
    }
    .type_content {
      .handicap,
      .trading {
        display: none;
      }
      .left_handicap {
        margin-right: 0;
      }
      .activeTabContent {
        display: block;
      }
    }
  }
}
</style>
